import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { PlatformToggleProps } from './types';

import { Sections } from 'types/global';

export const PlatformToggle = ({ onChange, activePlatform }: PlatformToggleProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Обновляем активную платформу при изменении URL
  useEffect(() => {
    onChange(location.pathname?.startsWith('/instagram') ? 'instagram' : 'telegram');
  }, [location.pathname]);

  const handlePlatformChange = (platform: Sections) => {
    onChange(platform);

    if (onChange) {
      onChange(platform);

      if (platform === 'telegram') {
        navigate('/');
      } else {
        navigate('/instagram');
      }
    }
  };

  return (
    <div className="flex rounded-md overflow-hidden border">
      <button
        className={`flex-1 py-2 px-3 text-sm flex items-center justify-center gap-1 ${
          activePlatform === 'telegram' ? 'bg-blue-50 text-[#59C9F9]' : 'bg-white text-gray-500 hover:bg-gray-50'
        }`}
        onClick={() => handlePlatformChange('telegram')}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32">
          <path
            fill="currentColor"
            d="M16 .5C7.437.5.5 7.438.5 16S7.438 31.5 16 31.5c8.563 0 15.5-6.938 15.5-15.5S24.562.5 16 .5m7.613 10.619l-2.544 11.988c-.188.85-.694 1.056-1.4.656l-3.875-2.856l-1.869 1.8c-.206.206-.381.381-.781.381l.275-3.944l7.181-6.488c.313-.275-.069-.431-.482-.156l-8.875 5.587l-3.825-1.194c-.831-.262-.85-.831.175-1.231l14.944-5.763c.694-.25 1.3.169 1.075 1.219z"
          />
        </svg>
        Telegram
      </button>
      <button
        className={`flex-1 py-2 px-3 text-sm flex items-center justify-center gap-1 ${
          activePlatform === 'instagram' ? 'bg-pink-50 text-pink-600' : 'bg-white text-gray-500 hover:bg-gray-50'
        }`}
        onClick={() => handlePlatformChange('instagram')}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-1">
          <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2" />
          <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
          <circle cx="18" cy="6" r="1" fill="currentColor" />
        </svg>
        Instagram
      </button>
    </div>
  );
};
